<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64" 
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">Add Text Group</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      
      <v-card class="card2" style="margin-top: 1rem">
        <v-flex class="flex">
          <v-row class="mb-4">
            <v-col cols="12" sm="12" md="5">
              <v-text-field 
                id="textgroupname-field-replacetext" 
                label="Text Group Name" 
                v-model="ReplaceText.Name" 
                variant="outlined"
                density="comfortable"
                color="primary"
                class="modern-text-field ml-6"
                clearable
                hide-details="auto"
                :readonly="!!ReplaceText.GroupReplaceID"
                :disabled="!!ReplaceText.GroupReplaceID"
              >
                <template v-slot:prepend-inner>
                  <v-icon 
                    :color="ReplaceText.GroupReplaceID ? 'grey-darken-1' : 'primary'" 
                    size="small"
                  >
                    {{ ReplaceText.GroupReplaceID ? 'mdi-database' : 'mdi-pencil-box-outline' }}
                  </v-icon>
                </template>
                
                <template v-slot:append-inner>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <v-icon 
                        v-bind="props"
                        color="grey-darken-1"
                        size="small"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{ $t('_InfoReplaceGroup') }}</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
            
            <v-col cols="12" md="7" class="d-flex justify-end align-center pr-10">
              <a 
                id="downloadtemplate-replacetext" 
                @click="DownloadTemplate()" 
                class="download-link mr-4"
                style="cursor: pointer;"
              > 
                <v-icon size="18" class="mr-1">mdi-download</v-icon>
                Template 
              </a>

              <!-- Custom Upload Button -->
              <v-btn
                v-if="permissions.add"
                id="button-upload-replacement"
                @click="triggerFileUpload"
                variant="outlined"
                color="success"
                size="large"
                class="upload-btn mr-3"
                prepend-icon="mdi-upload"
              >
                <span class="btn-text">Upload CSV</span>
              </v-btn>

              <!-- Hidden DragDropFile Component -->
              <DragDropFile
                ref="dragDropFileRef"
                :dialog="false"
                :DragDrop="false"
                :ShowListFile="false"
                :allowType="['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']"
                accept=".csv, .xlsx"
                @filesUploaded="processUpload($event)"
                style="display: none;"
              />

              <v-btn
                v-if="permissions.add"
                id="button-add-replacement"
                @click="Add()"
                variant="flat"
                color="primary"
                size="large"
                class="add-replacement-btn ml-3"
                prepend-icon="mdi-plus-circle"
                elevation="2"
              >
                {{ $t('add') }}
              </v-btn>
            </v-col>
          </v-row>

          <v-data-table-server
            class="modern-table"
            :items-per-page="itemsPerPage"
            :items-length="searchTotalTable"
            v-model:options="options"
            :items="menus"
            :headers="headers"
            :loading="dialog"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td style="text-align: center">{{ item.number }}</td>
                <td>{{ item.focusKey }}</td>
                <td>{{ item.replaceKey.length > 20 ? item.replaceKey.substring(0, 20) + '...' : item.replaceKey }}</td>
                <td style="text-align: center">
                  <div class="action-group" style="justify-content: center;">
                    <!-- Edit -->
                    <v-btn
                      v-if="permissions.edit || permissions.view"
                      id="button-edit-popupedit-replacement"
                      variant="text"
                      density="comfortable"
                      @click="Edit(item)"
                      class="action-btn edit-btn"
                      icon
                    >
                      <v-icon size="18">{{ isViewOnly ? 'mdi-eye-outline' : 'mdi-pencil-outline' }}</v-icon>
                      <v-tooltip activator="parent" location="top">
                        {{ isViewOnly ? 'View' : 'Edit' }}
                      </v-tooltip>
                    </v-btn>

                    <!-- Custom Divider -->
                    <div v-if="permissions.edit && permissions.delete" class="action-divider"></div>

                    <!-- Delete -->
                    <v-btn
                      v-if="permissions.delete"
                      id="button-delete-popupedit-replacement"
                      variant="text"
                      density="comfortable"
                      @click="DeleteReplaceText(item.replaceID)"
                      class="action-btn delete-btn"
                      icon
                    >
                      <v-icon size="18">mdi-delete-outline</v-icon>
                      <v-tooltip activator="parent" location="top">
                        Delete
                      </v-tooltip>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table-server>
        </v-flex>
        <br />
      </v-card>
    </v-container>

    <!-- Loading Please Wait... -->
    <v-overlay :value="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>

    <!-- Edit Dialog -->
    <v-dialog v-model="Editdialog" max-width="700px" class="modern-dialog">
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-edit">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background">
                <v-icon color="white" size="32">mdi-pencil</v-icon>
              </div>
            </div>
            <div class="header-text-content">
              <h2 class="dialog-title">{{ $t('edit') }}</h2>
              <p class="dialog-subtitle">Modify the replacement text</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn 
            icon 
            variant="text" 
            @click="closeEditDialog"
            class="close-button"
            color="white"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="dialog-content">
          <v-row>
            <v-col cols="12">
              <div class="field-container">
                <v-text-field 
                  id="specifictext-field-popupadd-replacement" 
                  :label="$t('SpecificText')" 
                  v-model="ReplaceText.FocusKey" 
                  :rules="[rules.required]" 
                  variant="outlined"
                  density="comfortable"
                  color="primary"
                  class="modern-field"
                  hide-details="auto"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="primary" size="small">mdi-text-search</v-icon>
                  </template>
                </v-text-field>
              </div>
            </v-col>
            <v-col cols="12">
              <div class="field-container">
                <v-text-field 
                  id="replacementtext-field-popupadd-replacement" 
                  :label="$t('replaceText')" 
                  v-model="ReplaceText.ReplaceKey" 
                  :rules="[rules.required]" 
                  variant="outlined"
                  density="comfortable"
                  color="primary"
                  class="modern-field"
                  hide-details="auto"
                  :error="errorMessage.replacementText.isRequired"
                  :error-messages="errorMessage.replacementText.required"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="primary" size="small">mdi-text</v-icon>
                  </template>
                </v-text-field>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn 
            variant="outlined"
            color="grey"
            size="large"
            @click="closeEditDialog"
            class="cancel-btn"
            prepend-icon="mdi-close"
          >
            {{ $t('close') }}
          </v-btn>
          <v-btn
            v-if="permissions.edit"
            id="button-save-popupedit-replacement"
            variant="flat"
            size="large"
            @click="SaveEdit()"
            class="dialog-action-btn save-btn-edit"
            prepend-icon="mdi-content-save"
          >
            {{ $t('save') }} 
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add Dialog -->
    <v-dialog v-model="Adddialog" max-width="700px" class="modern-dialog">
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background">
                <v-icon color="white" size="32">mdi-plus-circle</v-icon>
              </div>
            </div>
            <div class="header-text-content">
              <h2 class="dialog-title">{{ $t('add') }}</h2>
              <p class="dialog-subtitle">Add new replacement text</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn 
            icon 
            variant="text" 
            @click="closeAddDialog"
            class="close-button"
            color="white"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="dialog-content">
          <v-row>
            <v-col cols="12">
              <div class="field-container">
                <v-text-field 
                  id="originaltext-field-popupadd-replacement" 
                  label="Original Text" 
                  v-model="ReplaceText.FocusKey" 
                  :rules="[rules.required]" 
                  variant="outlined"
                  density="comfortable"
                  color="primary"
                  class="modern-field"
                  hide-details="auto"
                  :error="errorMessage.originalText.isRequired"
                  :error-messages="errorMessage.originalText.required"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="primary" size="small">mdi-text-search</v-icon>
                  </template>
                </v-text-field>
              </div>
            </v-col>
            <v-col cols="12">
              <div class="field-container">
                <v-text-field 
                  id="replacementtext-field-popupadd-replacement" 
                  label="Replacement Text" 
                  v-model="ReplaceText.ReplaceKey" 
                  :rules="[rules.required]" 
                  variant="outlined"
                  density="comfortable"
                  color="primary"
                  class="modern-field"
                  hide-details="auto"
                  :error="errorMessage.replacementText.isRequired"
                  :error-messages="errorMessage.replacementText.required"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="primary" size="small">mdi-text</v-icon>
                  </template>
                </v-text-field>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn 
            variant="outlined"
            color="grey"
            size="large"
            @click="closeAddDialog"
            class="cancel-btn"
            prepend-icon="mdi-close"
          >
            {{ $t('close') }}
          </v-btn>
          <v-btn
            v-if="permissions.add"
            id="button-save-popupadd-replacement"
            variant="flat"
            size="large"
            @click="SaveAdd()"
            class="dialog-action-btn save-btn-add"
            prepend-icon="mdi-content-save"
          >
            {{ $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPermissionTwo from '@/api/function.js';
import DragDropFile from '@/components/DragDropFile.vue';
import editImg from '@/assets/edit1.png';
import deleteImg from '@/assets/delete1.png';
export default {
  name: 'ReplaceText',
  inject: ['flagNav','FontColorTitle','SubNavbarBackGround'],
  mixins: [checkPermissionTwo],
  components: { DragDropFile },
  data: () => ({
    isInitialized: false,
    checkbox1: false,
    Editdialog: false,
    Adddialog: false,
    dialog: false,
    valid: true,
    tempID: 0,
    today: null,
    maxLengthChar: 0,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    loading: true,
    options: {},
    rules: {
      required: (value) => !!value || 'Required.',
    },
    searchName: '',
    isSearch: false,
    isFirst: true,
    menus: [],
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    ReplaceText: {
      GroupReplaceID: null,
      Name: null,
      ReplaceID: null,
      FocusKey: null,
      ReplaceKey: null,
    },
    files: [],
    uploadedFiles: [],
    entity: null,
    sortBy: [],
    sortDesc :[],

    errorMessage : {
      originalText: {
        required: '',
        isRequired : false,
      },
      replacementText: {
        required: '',
        isRequired : false,
      },
    }
  }),
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('GroupTextReplacement');
    },
    permissions() {
      return {
        add: this.$pagePermission && this.$pagePermission.canAdd('GroupTextReplacement'),
        edit: this.$pagePermission && this.$pagePermission.canEdit('GroupTextReplacement'),
        delete: this.$pagePermission && this.$pagePermission.canDelete('GroupTextReplacement'),
      }
    },
    headers() {
      return [
        { title: this.$t('no'), align: 'center', sortable: false, width: '95px' },
        { title: 'Original Text', align: 'left', sortable: true,value:'FocusKey' },
        { title: 'Replacement Text', align: 'left', sortable: true ,value:'ReplaceKey'},
        { title: 'Action', align: 'center', sortable: false, width: '150px' },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        if (!this.isInitialized) return;
        this.Get();
      },
      deep: true,
    },

    'ReplaceText.FocusKey'(val) {
      if (val) {
        this.errorMessage.originalText.isRequired = false;
        this.errorMessage.originalText.required = '';
      }
    },
    'ReplaceText.ReplaceKey'(val) {
      if (val) {
        this.errorMessage.replacementText.isRequired = false;
        this.errorMessage.replacementText.required = '';
      }
    },
  },
  methods: {
    
    triggerFileUpload() {
      // กดที่ DragDropFile component ผ่าน ref
      if (this.$refs.dragDropFileRef) {
        // หาค element ที่เป็น input file หรือ button ใน DragDropFile component
        const fileInput = this.$refs.dragDropFileRef.$el.querySelector('input[type="file"]');
        const uploadButton = this.$refs.dragDropFileRef.$el.querySelector('button');
        
        if (fileInput) {
          fileInput.click();
        } else if (uploadButton) {
          uploadButton.click();
        }
        // หรือถ้า DragDropFile มี method เปิด dialog
        // this.$refs.dragDropFileRef.openDialog();
      }
    },
    Get() {
      let self = this;
      self.dialog = true;
      
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        id: self.ReplaceText.GroupReplaceID,
        sortDesc: sortOrder,
        sortBy: sortField
      };
      self.$call.GetTableReplaceText(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.menus = dataResponse.data.data.listReplaceText;
            self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
          } else {
            self.menus = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },

    Add() {
      let self = this;
      self.ReplaceText.ReplaceID = null;
      self.ReplaceText.FocusKey = null;
      self.ReplaceText.ReplaceKey = null;
      self.Adddialog = true;
    },
    Edit(item) {
      let self = this;
      self.Editdialog = true;
      self.ReplaceText.ReplaceID = item.replaceID;
      self.ReplaceText.FocusKey = item.focusKey;
      self.ReplaceText.ReplaceKey = item.replaceKey;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },
    async SaveAdd() {
      let self = this;

      if ((self.ReplaceText.FocusKey == null || self.ReplaceText.FocusKey == '') ||
          (self.ReplaceText.ReplaceKey == null || self.ReplaceText.ReplaceKey == '')
      ) {
        if (self.ReplaceText.FocusKey == null || self.ReplaceText.FocusKey == '') {
          self.errorMessage.originalText.required = 'Required';
          self.errorMessage.originalText.isRequired = true;
        }
        if (self.ReplaceText.ReplaceKey == null || self.ReplaceText.ReplaceKey == '') {
          self.errorMessage.replacementText.required = 'Required';
          self.errorMessage.replacementText.isRequired = true;
          
        }
        return;
      }
      if (
        self.ReplaceText.Name == null ||
        self.ReplaceText.Name == ''
        // self.ReplaceText.FocusKey == null ||
        // self.ReplaceText.FocusKey == '' ||
        // self.ReplaceText.ReplaceKey == null ||
        // self.ReplaceText.ReplaceKey == ''
      ) {
        // alert('Please Fill All The Fields!');
        self.$swal.fire({
          icon: 'warning',
          title: 'Please Fill Text Group Name Fields!',
          showConfirmButton: false,
          timer: 1800,
        });
        return;
      }
      self.dialog = true;
      try {
        if (self.ReplaceText.GroupReplaceID == null) {
          let list = [{ FocusKey: self.ReplaceText.FocusKey, ReplaceKey: self.ReplaceText.ReplaceKey }];
          let temp = {
            GroupReplaceID: null,
            Name: self.ReplaceText.Name,
            ListReplaceText: list,
          };
          await self.$call.CreateGroupReplace(
            temp,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                if (dataResponse.data == -1) {
                  self.$swal.fire({
                    icon: 'warning',
                    title: 'Group name is duplicate',
                    showConfirmButton: false,
                    timer: 1800,
                  });
                } else {
                  self.$swal.fire({
                    icon: 'success',
                    title: dataResponse.message,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  self.ReplaceText.GroupReplaceID = dataResponse.data;
                  self.totalTable = self.totalTable+1;
                  self.Get();

                  //  repalace the current route query parameters not reload the page
                  const currentQuery = { ...this.$route.query };
                  currentQuery.name = self.ReplaceText.Name;
                  currentQuery.id = dataResponse.data;
                  self.$router.replace({
                    path: this.$route.path,
                    query: currentQuery,
                  });
                }
                self.Adddialog = false;
              }else if (dataResponse.status == 3) {
                self.$swal.fire({
                  icon: 'warning',
                  title: 'Group name is duplicate',
                  showConfirmButton: false,
                  timer: 1800,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        } else {
          // ReplaceText.Name
          let temp = {
            GroupReplaceID: self.ReplaceText.GroupReplaceID,
            Name: self.ReplaceText.Name,
            FocusKey: self.ReplaceText.FocusKey,
            ReplaceKey: self.ReplaceText.ReplaceKey,
          };
          await self.$call.CreateReplaceText(
            temp,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.totalTable = self.totalTable+1;
                self.Get();
                self.Adddialog = false;

                //  repalace the current route query parameters not reload the page
                  const currentQuery = { ...this.$route.query };
                  currentQuery.name = self.ReplaceText.Name;
                  currentQuery.id = dataResponse.data;
                  self.$router.replace({
                    path: this.$route.path,
                    query: currentQuery,
                  });
              }
              else if (dataResponse.status == 3) {
                self.$swal.fire({
                  icon: 'warning',
                  title: 'Group name is duplicate',
                  showConfirmButton: false,
                  timer: 1800,
                });
              }
              console.log(dataResponse);
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    async SaveEdit() {
      let self = this;

      if ((self.ReplaceText.FocusKey == null || self.ReplaceText.FocusKey == '') ||
          (self.ReplaceText.ReplaceKey == null || self.ReplaceText.ReplaceKey == '')
      ) {
        if (self.ReplaceText.FocusKey == null || self.ReplaceText.FocusKey == '') {
          self.errorMessage.originalText.required = 'Required';
          self.errorMessage.originalText.isRequired = true;
        }
        if (self.ReplaceText.ReplaceKey == null || self.ReplaceText.ReplaceKey == '') {
          self.errorMessage.replacementText.required = 'Required';
          self.errorMessage.replacementText.isRequired = true;
          
        }
        return;
      }
      self.dialog = true;
      try {
        if (self.Editdialog) {
          let temp = {
            GroupReplaceID: self.ReplaceText.GroupReplaceID,
            Name: self.ReplaceText.Name,
            ReplaceID: self.ReplaceText.ReplaceID,
            FocusKey: self.ReplaceText.FocusKey,
            ReplaceKey: self.ReplaceText.ReplaceKey,
          };
          await self.$call.UpdateReplaceText(
            temp,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.Get();
                self.Editdialog = false;
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Editdialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    DeleteReplaceText(id) {
      let self = this;
      self.$swal
        .fire({
          title: this.$t('confirmDeletion'),
          text: this.$t('confirmDeletionMessage'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.dialog = true;
            self.$call.DeleteReplaceText(
              id,
              (dataResponse) => {
                if (dataResponse.status == 0) {
                  self.dialog = false;
                  self.$swal.fire({
                    icon: 'success',
                    title: dataResponse.message,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  self.Get();
                }
                self.dialog = false;
              },
              (errorResource) => {
                self.dialog = false;
                console.error(errorResource);
              }
            );
          }
        });
      // });
      // } catch (error) {
      //   this.LogTrace(error, 'DeleteGroup');
      // }
    },
    DownloadTemplate() {
      const data = [
        ['Text', 'Replace_Text'],
        ['ฟุตบอล', 'Football'],
        ['ปิงปอง', 'pingpong'],
      ];
      // จัดรูปแบบข้อมูลในรูปแบบของ CSV
      const csvContent = data.map((row) => row.join(',')).join('\n');
      const blob = new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), csvContent], { type: 'text/csv;charset=utf-8;' });

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);

      link.download = 'replace_text_template.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    processUpload(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.uploadedFiles = [];
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]);
      reader.onload = () => {
        this.ValidateFile(this.files);
        this.ConfirmProcess();
      };
    },
    ValidateFile(files) {
      const formDataDoc = new FormData();
      formDataDoc.append('uploaded_file', files[0]);
      this.uploadedFiles = files;
      this.entity = formDataDoc;
    },
    ConfirmProcess() {
      let self = this;
      self.$swal
        .fire({
          title: this.$t('importReplaceTextTitle'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('cancel'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.Save();
          }
        });
    },

    Save() {
      let self = this;
      if (!self.ReplaceText.Name) {
         self.$swal.fire({
          icon: 'warning',
          title: 'Please Fill Text Group Name!',
          showConfirmButton: false,
          timer: 1800,
        });
        // alert('Please Fill All The Fields!');
        return;
      }
      self.dialog = true;
      try {
        let temp = {
          groupName: self.ReplaceText.Name,
          uploaded_file: self.entity,
          groupReplaceID: self.ReplaceText.GroupReplaceID,
          DeleteAll: false,
        };
        self.$call.UploadFileReplaceText(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              if (dataResponse.data.groupReplaceID == 0) {
                self.$swal.fire({
                  icon: 'warning',
                  title: 'Format Excel/CSV incorrect',
                  showConfirmButton: false,
                  timer: 1800,
                });
              } else if (dataResponse.data.groupReplaceID == -1) {
                self.$swal.fire({
                  icon: 'warning',
                  title: 'Group name is duplicate',
                  showConfirmButton: false,
                  timer: 1800,
                });
              } else {
                self.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.ReplaceText.GroupReplaceID = dataResponse.data.groupReplaceID;
                self.totalTable = dataResponse.data.totalPage;
                self.isFirst = true;
              }
              self.uploadedFiles = [];
              self.Get();
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },

    closeAddDialog() {
      this.Adddialog = false;
      this.ReplaceText.FocusKey = null;
      this.ReplaceText.ReplaceKey = null;
      this.errorMessage.originalText.isRequired = false;
      this.errorMessage.originalText.required = '';
      this.errorMessage.replacementText.isRequired = false;
      this.errorMessage.replacementText.required = '';
    },
    closeEditDialog() {
      this.Editdialog = false;
      this.ReplaceText.FocusKey = null;
      this.ReplaceText.ReplaceKey = null;
      this.errorMessage.originalText.isRequired = false;
      this.errorMessage.originalText.required = '';
      this.errorMessage.replacementText.isRequired = false;
      this.errorMessage.replacementText.required = '';
    },
  },
  mounted() {
    this.GetDate();
    if (this.$route.query.id) {
      this.ReplaceText.Name = this.$route.query.name;
      this.ReplaceText.GroupReplaceID = this.$route.query.id;
    }
    this.Get();
    this.isInitialized = true;
  },
};
</script>

<style scoped>
/* =============================================================================
   BASE STYLES (from PromptTemplate.vue)
   ============================================================================= */
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

/* =============================================================================
   TEXT FIELD STYLES (from PromptTemplate.vue)
   ============================================================================= */
.modern-text-field {
  margin-top: 8px;
}

.modern-text-field :deep(.v-field) {
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease !important;
}

.modern-text-field :deep(.v-field__outline) {
  border-width: 2px !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  transition: all 0.3s ease !important;
}

.modern-text-field :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.modern-text-field:hover :deep(.v-field__outline) {
  border-color: rgba(25, 118, 210, 0.6) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

/* Read-only state */
.modern-text-field :deep(.v-field--readonly) {
  background: #f8f9fa !important;
  opacity: 0.9;
}

.modern-text-field :deep(.v-field--readonly .v-field__outline) {
  border-color: rgba(0, 0, 0, 0.08) !important;
  border-style: dashed !important;
}

.modern-text-field :deep(.v-field--readonly:hover .v-field__outline) {
  border-color: rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04) !important;
}

/* Label and input styling */
.modern-text-field :deep(.v-label) {
  font-weight: 600 !important;
  color: #495057 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.25px !important;
}

.modern-text-field :deep(.v-field--focused .v-label) {
  color: #1976d2 !important;
}

.modern-text-field :deep(.v-field--readonly .v-label) {
  color: #6c757d !important;
}

.modern-text-field :deep(.v-field__input) {
  font-size: 1rem !important;
  font-weight: 500 !important;
  color: #333 !important;
  padding: 16px 12px !important;
}

.modern-text-field :deep(.v-field--readonly .v-field__input) {
  color: #6c757d !important;
}

.modern-text-field :deep(.v-field__input::placeholder) {
  color: #adb5bd !important;
  font-style: italic;
}

/* Icon styling */
.modern-text-field :deep(.v-field__prepend-inner) {
  padding-right: 8px !important;
}

.modern-text-field :deep(.v-field__append-inner) {
  padding-left: 8px !important;
}

/* =============================================================================
   BUTTON STYLES (from PromptTemplate.vue)
   ============================================================================= */
.add-replacement-btn {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%) !important;
  color: white !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  border-radius: 12px !important;
  padding: 8px 24px !important;
  min-width: 160px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 3px 12px rgba(25, 118, 210, 0.3) !important;
}

.add-replacement-btn:hover {
  background: linear-gradient(135deg, #1565c0 0%, #0d47a1 100%) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(25, 118, 210, 0.4) !important;
}

.download-link {
  color: #1976d2 !important;
  text-decoration: none !important;
  font-weight: 500 !important;
  font-size: 0.875rem !important;
  display: flex !important;
  align-items: center !important;
  transition: all 0.3s ease !important;
  padding: 8px 12px !important;
  border-radius: 8px !important;
}

.download-link:hover {
  background: rgba(25, 118, 210, 0.1) !important;
  color: #1565c0 !important;
  text-decoration: none !important;
}

/* =============================================================================
   DATA TABLE STYLES (from PromptTemplate.vue)
   ============================================================================= */
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

.action-divider {
  width: 1px;
  height: 20px;
  background: #dee2e6;
  margin: 0 8px;
  transition: all 0.3s ease;
}

.action-group {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* =============================================================================
   DIALOG STYLES (from PromptTemplate.vue)
   ============================================================================= */
/* .modern-dialog :deep(.v-overlay) {
  z-index: 200 !important;
}

.modern-dialog :deep(.v-overlay__content) {
  margin: 24px;
  animation: dialogSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 201 !important;
}

.dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.2) !important;
}

.dialog-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
  padding: 24px !important;
  position: relative;
  border-bottom: none !important;
}

.header-icon-container {
  background: rgba(25, 118, 210, 0.1);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.header-text {
  flex: 1;
} */

/* .dialog-title {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  color: #2c3e50 !important;
  margin-bottom: 4px !important;
  line-height: 1.2 !important;
} */

/* .dialog-subtitle {
  font-size: 0.875rem !important;
  color: #6c757d !important;
  margin: 0 !important;
  font-weight: 400 !important;
} */

/* .close-btn {
  position: absolute !important;
  top: 16px !important;
  right: 16px !important;
  background: rgba(255, 255, 255, 0.8) !important;
  border-radius: 50% !important;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 1) !important;
  transform: scale(1.1) !important;
} */

.dialog-content {
  padding: 32px 24px !important;
  background: #ffffff;
}

.field-container {
  margin-bottom: 16px;
}

.modern-field :deep(.v-field__outline) {
  border-radius: 12px !important;
}

.modern-field :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.dialog-actions {
  background: rgba(248, 249, 250, 0.5) !important;
  padding: 20px 24px !important;
  gap: 12px;
}

.cancel-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  border-color: #dee2e6 !important;
  color: #6c757d !important;
}

.cancel-btn:hover {
  background: #f8f9fa !important;
  border-color: #adb5bd !important;
  color: #495057 !important;
}

.save-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3) !important;
  transition: all 0.3s ease !important;
}

.save-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(25, 118, 210, 0.4) !important;
}

.save-edit-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  box-shadow: 0 4px 12px rgba(255, 164, 7, 0.3) !important;
  transition: all 0.3s ease !important;
}

.save-edit-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(255, 164, 7, 0.4) !important;
}
/* =============================================================================
   UPLOAD BUTTON STYLES
   ============================================================================= */
.upload-btn {
  background: #ffffff !important;
  border: 2px solid #28a745 !important;
  color: #28a745 !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  border-radius: 12px !important;
  padding: 8px 24px !important;
  min-width: 160px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.15) !important;
}

.upload-btn:hover {
  background: #28a745 !important;
  color: #ffffff !important;
  border-color: #28a745 !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.3) !important;
}

.upload-btn .v-icon {
  transition: transform 0.3s ease !important;
}

.upload-btn:hover .v-icon {
  transform: scale(1.1) !important;
}

/* Upload States */
.upload-btn.uploading {
  background: #ffc107 !important;
  border-color: #ffc107 !important;
  color: #212529 !important;
  pointer-events: none;
}

.upload-btn.success {
  background: #28a745 !important;
  border-color: #28a745 !important;
  color: #ffffff !important;
  animation: successPulse 0.5s ease;
}

@keyframes successPulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

/* Button Text Animation */
.btn-text {
  transition: all 0.3s ease;
  position: relative;
}

.upload-btn:hover .btn-text {
  transform: translateX(2px);
}

/* Responsive Upload Button */
@media (max-width: 768px) {
  .upload-btn {
    min-width: 120px !important;
    padding: 6px 16px !important;
  }
  
  .upload-btn .btn-text {
    font-size: 0.875rem;
  }
}

/* =============================================================================
   ANIMATIONS
   ============================================================================= */
@keyframes dialogSlideIn {
  from {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* =============================================================================
   RESPONSIVE DESIGN
   ============================================================================= */
@media (max-width: 768px) {
  .modern-text-field :deep(.v-field__input) {
    font-size: 0.9rem !important;
    padding: 14px 10px !important;
  }
  
  .modern-text-field :deep(.v-label) {
    font-size: 0.8rem !important;
  }

  .dialog-header {
    padding: 20px 16px !important;
  }
  
  .header-icon-container {
    width: 48px;
    height: 48px;
    margin-right: 12px;
  }
  
  .dialog-title {
    font-size: 1.25rem !important;
  }
  
  .dialog-content {
    padding: 24px 16px !important;
  }
  
  .dialog-actions {
    padding: 16px !important;
    flex-direction: column;
  }
  
  .cancel-btn,
  .save-btn,
  .save-edit-btn {
    width: 100% !important;
    min-width: auto !important;
  }
}

.modern-table :deep(.v-table__wrapper) {
  max-height: 600px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper thead) {
  position: sticky;
  top: 0;
  z-index: 2;
}

.modern-table :deep(.v-table__wrapper thead th) {
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}
</style>
